import { SIGNUP_SUCCESSFUL } from "@constants/signupSuccessful";
import { Cookie } from "@utils/Cookie";
import { setLocalStorageItem } from "@utils/LocalStorage";
import { logger } from "@utils/logger";
import { partnerStackSignUp } from "@utils/partnerstack";
import { segmentTrack } from "@utils/segment/segment-track";
import { setSsoCookies } from "@utils/setSsoCookies";
import { OnAxiosSuccessFC } from "./sfd-form.type";
import { fireExtoleSignUp } from "@utils/extole/fireExtoleSignUp";
import { trackMxpEvent } from "@utils/mixpanelEvents/mixpanelEvents";

export const onSuccess: OnAxiosSuccessFC = ({
  res,
  email,
  name,
  phone,
  profession,
  termsOfServiceAcceptance,
  reqEndTime,
  questions,
  otherProfession,
}) => {
  setSsoCookies(res);
  const redirectUrl = res.data?.attributes?.signInRedirectUrl;

  const treatedQuestions = removeEmptyArraysFromQuestions(questions);

  const promoCode = Cookie.getCookie("PROMOCODE")
    ? Cookie.getCookie("PROMOCODE")
    : "";

  if (redirectUrl) {
    const distinctId = JSON.parse(
      decodeURIComponent(Cookie.getCookie(process.env.GATSBY_MIXPANEL_ID)!)
    )?.distinct_id;
    trackMxpEvent("user: sign up completed", {
      $current_url: window.location.href,
      email,
      ...treatedQuestions,
    });

    setLocalStorageItem(SIGNUP_SUCCESSFUL, "true");
    const [first_name, last_name] = name.split(" ");
    const consentOpts = {
      false: "No",
      true: "Yes",
    };

    segmentTrack("Trial Sign Up Completed", {
      first_name,
      last_name,
      phone,
      email,
      specialty: profession,
      consent: consentOpts[`${termsOfServiceAcceptance}`] || "Blank",
      url: window.location.pathname,
      time_spent: reqEndTime,
      object: "Trial Sign Up",
      action: "Completed",
      initiator: "User",
      source_application: "Marketing",
      ...treatedQuestions,
      other_specialty: otherProfession?.trim() || "(not set)",
      competitoruser_intent:
        Cookie.getCookie("competitorUserIntent") || "(not set)",
      user_intent: Cookie.getCookie("userIntent") || "(not set)",
      ...(promoCode && { promo_code: promoCode }),
    });

    fireExtoleSignUp({
      email,
      first_name,
      last_name,
    });

    window.dataLayer.push({
      event: "sign_up",
      user_id: distinctId,
      first_name,
      last_name,
      email,
      phone,
      profession,
    });

    if (!res.data?.id) {
      window.location.href = redirectUrl;
      return;
    } else {
      partnerStackSignUp({ customer_key: res.data.id });
      window.location.href = redirectUrl;
    }
  } else {
    logger("Oops something went wrong, please try again later...");
    logger(res);
  }

  window.grecaptcha.reset();
};

function removeEmptyArraysFromQuestions(
  questions: {
    [key: string]: string | null;
  } | null
) {
  const copied_questions = { ...questions };
  for (let key in copied_questions) {
    if (copied_questions.hasOwnProperty(key)) {
      if (
        Array.isArray(copied_questions[key]) &&
        copied_questions[key].length === 0
      ) {
        copied_questions[key] = null;
      }
    }
  }
  return copied_questions;
}
